import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  Card,
  Row,
  Space,
  ProgressBar,
  Button,
} from "@masterteam/mt-design-react";
import useIsAr from "../../../Hooks/useIsAr";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";

import "./style.scss";

const ProgramCard = ({ data, setProgramFormModel, setDeleteModal }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();

  return (
    <Card className="card-wrapper">
      <Row className="title" align="center" justify="between">
        <div className="value">{isAr ? data.ArabicName : data.EnglishName}</div>
        <Space size="small">
          {data?.IsEditable && (
            <Button
              variant="dark"
              shape="circle"
              backgroundColor="var(--primary-color)"
              Icon={EditIcon}
              onClick={(e) => {
                e.stopPropagation();
                setProgramFormModel({ isOpen: true, data });
              }}
            />
          )}

          {data?.IsDeletable && (
            <Button
              variant="error"
              shape="circle"
              backgroundColor="var(--primary-color)"
              Icon={DeleteIcon}
              onClick={(e) => {
                e.stopPropagation();
                setDeleteModal({ isOpen: true, data: data.ID });
              }}
            />
          )}
        </Space>
      </Row>

      <Row className="owner" justify="between">
        <Space direction="vertical" size="small">
          <div className="value">{data?.OwnerModel?.DisplayName}</div>
          <div className="label">
            {intl.formatMessage({
              id: "program.owner",
            })}
          </div>
        </Space>

        <Space direction="vertical" size="small">
          <div className="value">{data?.SponsorModel?.DisplayName}</div>
          <div className="label">
            {intl.formatMessage({
              id: "program.sponsor",
            })}
          </div>
        </Space>
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar value={data?.Progress} color={data.ColorCode} />
        <span style={{ color: data.ColorCode }}>{data.Progress} %</span>
      </Row>

      <Row className="details" justify="between">
        <Space direction="vertical" className="item">
          <div className="value">{data?.ProjectsCount}</div>
          <div>
            {intl.formatMessage({
              id: "common.projects",
            })}
          </div>
        </Space>

        <Space direction="vertical" className="item">
          <div className="value">{data?.RisksCount}</div>
          <div>
            {intl.formatMessage({
              id: "common.risks",
            })}
          </div>
        </Space>

        <Space direction="vertical" className="item">
          <div className="value">{data?.IssuesCount}</div>
          <div>
            {intl.formatMessage({
              id: "common.issues",
            })}
          </div>
        </Space>
      </Row>
    </Card>
  );
};

export default ProgramCard;
